import { SMLAnalytics } from './sml/analytics';

export const UniversalAnalytics = SMLAnalytics;
